import { render, staticRenderFns } from "./GarantiasCredito.vue?vue&type=template&id=56356713&scoped=true"
import script from "./GarantiasCredito.vue?vue&type=script&lang=js"
export * from "./GarantiasCredito.vue?vue&type=script&lang=js"
import style0 from "./GarantiasCredito.vue?vue&type=style&index=0&id=56356713&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56356713",
  null
  
)

export default component.exports